import { defineMeta } from '@/registry/types';

export const tableExampleMeta = defineMeta({
  name: 'TableExample',
  level: 'page',
  category: 'example',
  classification: 'custom',
  description: 'Reference inventory list page with search-driven filtering and an empty state.',
  baseLibrary: 'custom',
  importPath: '@/pages/TableExample',
  supportedStates: ['default', 'empty'],
  designTokens: ['colors', 'spacing', 'severity'],
  accessibility: ['Demonstrates TablePageLayout heading + table semantics.'],
  usageExamples: ['<TableExample />'],
  antiPatterns: ['Example only; adapt data wiring for production.'],
  llmSafe: false,
  whenToUse: ['Reference for building list/table pages'],
  whenNotToUse: ['Directly in production without adapting data'],
});

export default tableExampleMeta;
